var map = {
	"./1_1_1.jpg": "c524",
	"./1_1_2.jpg": "1464",
	"./1_2_1.jpg": "602a",
	"./1_3_1.jpg": "69f0",
	"./1_4_1.jpg": "3ccf",
	"./1_4_2.jpg": "d350"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9514";